import { useState } from "react";

const FAQS = [
  {
    q: "“搭讪吃瓜”的内容都是从哪里来的？",
    a: "我们的内容由编辑团队与广大网友共同投稿整理而来，涵盖街头搭讪、地铁偶遇、相亲局、酒局、网络奔现等真实场景下的翻车名场面。所有内容在发布前都会经过基础筛选，确保能带给大家真实的欢乐，而非生硬的剧本化表演。",
  },
  {
    q: "我自己遇上了“搭讪社死”瞬间，可以投稿吗？",
    a: "当然欢迎！你可以在页面底部找到投稿入口，把你经历的尴尬瞬间、名场面或听到的被怼金句发给我们。一经选用，我们会注明作者来源，并尽量隐去个人信息，让你快乐吃瓜的同时也能安心围观。",
  },
  {
    q: "网站多久更新一次内容？",
    a: "我们会保持每日更新，重点栏目如“翻车现场精选”和“名场面TOP榜”基本做到当天更新，确保你每次点开都有新鲜的搭讪失败合集可看，不会让你白跑一趟。",
  },
  {
    q: "这些视频会涉及真人隐私或侵权吗？",
    a: "我们非常重视内容合规与隐私保护。涉及真人出镜的内容我们只做引用与二次创作盘点，并会尽量避免暴露可识别个人身份的信息。如有版权或隐私顾虑的内容，欢迎随时联系，我们会第一时间核实并处理下架。",
  },
  {
    q: "为什么看别人翻车会觉得很好笑？",
    a: "心理学上这属于“共情性尴尬”与“轻松解压”的结合：因为当事人不是我们自己，我们既能感受到那份尴尬，又能安全地释放情绪。这也是搭讪翻车名场面能让人反复上头的原因。",
  },
  {
    q: "网站里的名场面数据是怎么统计的？",
    a: "名场面TOP榜的播放、点赞与话题热度数据综合自各平台公开的传播表现与观众讨论热度，仅作为娱乐参考榜单，不构成任何数据排名与商业主张。",
  },
];

const schema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQ() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-white py-14 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mb-8 text-center md:mb-10">
          <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-amber-400 px-3 py-1 text-xs font-semibold text-stone-900">
            <i className="ri-star-fill" /> 吃瓜前必读
          </p>
          <h2 className="font-hand text-3xl text-stone-900 md:text-4xl">关于搭讪吃瓜的常见问题</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-stone-500 md:text-base">
            关于内容来源、投稿方式与版权规则，这里都给你说明白，吃瓜也吃得明明白白。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen ? "border-orange-300 bg-orange-50/60" : "border-stone-200 bg-stone-50/60"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <h3 className="text-sm font-semibold text-stone-900 md:text-base">{f.q}</h3>
                  <span
                    className={`grid h-8 w-8 shrink-0 place-items-center rounded-full transition-all ${
                      isOpen ? "rotate-45 bg-orange-500 text-white" : "bg-white text-stone-500"
                    }`}
                  >
                    <i className="ri-add-line text-lg" />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-stone-600 md:px-6 md:text-[15px]">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}